import { dateFormatter } from "@stadium/helpers/dayjs";
import capitalize from "lodash/capitalize";

import { DOT_REGEX, NON_ALPHANUMERIC_REGEX, POSITIVE_NUMBER_REGEX } from "./constants";

export const formatCardExpiry = ({ month, year }) => {
  const date = new Date(year, month - 1);
  return dateFormatter(date, { format: "MM/YY" });
};

export const normalizeCount = (value, { fraction = false } = {}) => {
  if (!value) return value;

  const params = value.match(POSITIVE_NUMBER_REGEX);
  if (params) {
    if (fraction) {
      const doesValEndInPeriod = value[value.length - 1] == ".";
      const periodCount = (value.match(DOT_REGEX) || []).length;
      if (doesValEndInPeriod && periodCount == 1) {
        return value;
      }
    }
    return params[0];
  }
  return "";
};

export const normalizeAlphaNumeric = (value) => value?.replaceAll(NON_ALPHANUMERIC_REGEX, "");

export const titleCase = (text = "") =>
  text
    .split(" ")
    .map((word) => capitalize(word))
    .join(" ");
